import Icon from "../Icon/Icon";
import classes from "./IconButton.module.scss";

const IconButton = ({
  icon,
  text,
  type,
  onClicked,
  iconPosition,
  customClasses,
  size,
  disabled,
}) => {
  let styleClasses = classes.IconButton;

  switch (type) {
    case "secondary":
      styleClasses = [styleClasses, classes.Secondary].join(" ");
      break;

    default:
      styleClasses = [styleClasses, classes.Primary].join(" ");
      break;
  }

  switch (size) {
    case "big":
      styleClasses = [styleClasses, classes.Big].join(" ");
      break;

    default:
      styleClasses = [styleClasses, classes.Normal].join(" ");
      break;
  }

  if (disabled) {
    styleClasses = [styleClasses, classes.Disabled].join(" ");
  }

  if (iconPosition === "left") {
    styleClasses = [styleClasses, classes.IconLeft].join(" ");
  }

  if (iconPosition === "right") {
    styleClasses = [styleClasses, classes.IconRight].join(" ");
  }

  if (customClasses) {
    styleClasses = [styleClasses, customClasses].join(" ");
  }

  return (
    <button onClick={onClicked} className={styleClasses} disabled={disabled}>
      {iconPosition === "left" && <Icon name={icon} />}
      {text}
      {iconPosition === "right" && <Icon name={icon} />}
    </button>
  );
};

export default IconButton;
